<div
  (click)="onProductClick(product())"
  class="product-card flex h-full cursor-pointer flex-col justify-between overflow-hidden rounded-lg text-sm font-bold shadow-S"
  [class.border]="productBorderColor()"
  [class.opacity-40]="!isAvailable(product()) || !isOrderingAllowed()"
  [class.cursor-pointer]="isAvailable(product()) && isOrderingAllowed()"
  [style.backgroundColor]="productBackgroundColor() | contentBuilderColor: '#FFFFFF'"
>
  @if (product().images?.thumbnail?.url) {
    <div
      [class]="getImageContainerClass()"
      [style.backgroundColor]="productImagePlaceholderColor() | contentBuilderColor"
    >
      @if (quantityInCart() > 0) {
        <span
          class="notranslate absolute right-2 top-2 z-1 inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-primary-600 px-1.5 text-xs font-bold text-white"
        >
          {{ quantityInCart() }}
        </span>
      }
      @if (product()[ProductKeys.Images]?.thumbnail?.url) {
        <img
          [src]="product()[ProductKeys.Images]?.thumbnail?.url"
          [alt]="product()[ProductKeys.Name]"
          class="h-full w-full rounded-t-lg object-cover"
        />
      }
    </div>
  }
  <div class="flex min-w-0 flex-1 flex-col px-3 py-2 text-sm">
    <p
      class="product-name flex-1 break-words pb-1 pt-1 font-accent text-sm font-bold lg:pb-2 lg:text-base"
      [style.color]="productNameColor() | contentBuilderColor"
    >
      {{ product()[ProductKeys.Name] }}
    </p>
    <div>
      @let visibleLabels = product().labels | appVisibleLabels;
      @if (displayProductLabels().displayLabels && visibleLabels?.length) {
        <ul class="mt-2 flex min-w-0 flex-wrap gap-1 xl:mt-3">
          @for (label of visibleLabels; track label) {
            <li class="min-w-0 max-w-full">
              <app-tag-atom
                class="[&_a]:whitespace-normal [&_a]:break-words"
                [bold]="false"
                [text]="label.name"
                [lineThrough]="label.line_through"
              ></app-tag-atom>
            </li>
          }
        </ul>
      }
      @if (!product()[ProductKeys.PriceToDisplay]) {
        <div class="product-price text-right">
          @if (product()[ProductKeys.Discount]) {
            <app-price-atom
              class="p-1.5 pl-0"
              [amount]="product()[ProductKeys.Discount] ?? 0"
            ></app-price-atom>
            @if (product()[ProductKeys.Price] > 0) {
              <app-tag-atom
                class="p-1.5"
                color="success"
                [text]="
                  product()[ProductKeys.Price]
                    | discountPercent: $any(product()[ProductKeys.Discount])
                "
              ></app-tag-atom>
            }
          } @else {
            <app-price-atom
              class="pb-1 pl-0"
              [amount]="product()[ProductKeys.Price]"
            ></app-price-atom>
          }
        </div>
      }
    </div>
    @if (product()[ProductKeys.PriceToDisplay]) {
      <div class="product-price">
        <span class="notranslate"> {{ product()[ProductKeys.PriceToDisplay] }}</span>
      </div>
    }
  </div>
</div>
